const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDictAdd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M231.7,254.1H39.7c-13.2-.3-23.7-11-23.7-24.2V26.1c0-13.3,10.8-24.2,24.2-24.2,0,0,.1,0,.2,0h176c13.2.3,23.7,11,23.7,24.2v155.4c0,6.5-2.4,12.7-7,17.3-6.4,5.9-15,8.8-23.7,8-22.9-.8-164.3,0-165.8,0-3.1-.3-6.2.6-8.6,2.4-1.7,2-2.5,4.6-2.2,7.2v13.6c0,4.4,3.4,8.1,7.8,8.2,0,0,.1,0,.2,0h192c4.4,0,8,3.6,8,8,0,4.4-3.5,8-7.9,8.1-.3,0-.7,0-1,0ZM40.3,17.9c-4.4,0-8,3.6-8,8,0,0,0,.1,0,.2v165.9c3.7-1.2,7.6-1.8,11.5-1.6,5.1,0,142.4-.8,165.6,0,4.2.5,8.5-.6,11.8-3.2,1.5-1.6,2.3-3.6,2.4-5.8V26.1c0-4.4-3.4-8.1-7.8-8.2,0,0-.1,0-.2,0H40.3Z",
    style: {
      fill: "#000",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.8,86.1h-44.1v-44.1c0-2.3-1.8-4.2-4.2-4.2h-29.4c-2.3,0-4.2,1.8-4.2,4.2v44.1h-44.1c-2.3,0-4.2,1.8-4.2,4.2v29.4c0,2.3,1.8,4.2,4.2,4.2h44.1v44.1c0,2.3,1.8,4.2,4.2,4.2h29.4c2.3,0,4.2-1.8,4.2-4.2v-44.1h44.1c2.3,0,4.2-1.8,4.2-4.2v-29.4c0-2.3-1.8-4.2-4.2-4.2h0Z",
    style: {
      fill: "#f22",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDictAdd);
export default __webpack_public_path__ + "static/media/dict-add.daf3d75e650bdfc88c7d06c9c2e40247.svg";
export { ForwardRef as ReactComponent };